import { Link } from "react-router-dom";
import { Logo } from "@/components/layout/Logo";
import { useT } from "@/i18n";
import LanguageSwitcher from "@/components/LanguageSwitcher";

const QUOTE_IMG = "https://images.pexels.com/photos/20516335/pexels-photo-20516335.jpeg";

export function AuthShell({ title, subtitle, children, footer }) {
  const t = useT();
  return (
    <div className="grid min-h-screen lg:grid-cols-2">
      {/* Brand panel */}
      <div className="relative hidden overflow-hidden lg:block">
        <img src={QUOTE_IMG} alt="" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#2C2C2A] via-[#2C2C2A]/60 to-[#2C2C2A]/30" />
        <div className="relative flex h-full flex-col justify-between p-12 text-oat">
          <Logo onDark />
          <div>
            <p className="font-display text-3xl leading-snug">{t("auth.quote")}</p>
            <p className="mt-4 text-sm text-oat/80">{t("auth.quote_attr")}</p>
          </div>
        </div>
      </div>

      {/* Form panel */}
      <div className="flex flex-col items-center justify-center px-6 py-12">
        <div className="absolute right-4 top-4">
          <LanguageSwitcher />
        </div>
        <div className="w-full max-w-sm">
          <div className="mb-8 lg:hidden">
            <Logo />
          </div>
          <h1 className="font-display text-3xl text-foreground">{title}</h1>
          {subtitle ? <p className="mt-2 text-sm text-muted-foreground">{subtitle}</p> : null}
          <div className="mt-8">{children}</div>
          {footer ? <div className="mt-6 text-center text-sm text-muted-foreground">{footer}</div> : null}
          <p className="mt-10 text-center text-xs text-muted-foreground">
            <Link to="/" className="hover:text-foreground">{t("auth.back_home")}</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
